import { SVGProps, Ref, forwardRef } from 'react';

export const SunOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M12.9 23.999h-1.8v-4.236a11 11 0 0 0 1.8 0z" fill="currentColor" />
                <path
                    d="M5.93 17.277q.47.564 1.055 1.01L4.151 21.12 2.88 19.848l2.838-2.84q.102.135.213.27"
                    fill="currentColor"
                />
                <path d="M21.122 19.848 19.85 21.12l-2.835-2.835a6.5 6.5 0 0 0 1.268-1.278z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.413 6.009c4.044.173 5.493 2.9 5.582 5.71L18 12c0 3-1.5 6-6 6s-6-3-6-6l.005-.281C6.097 8.815 7.64 6 12 6zM12 7.799c-1.817 0-2.77.586-3.305 1.228-.583.7-.895 1.74-.895 2.973s.312 2.272.895 2.973c.536.642 1.488 1.227 3.305 1.227s2.77-.585 3.305-1.227c.583-.7.895-1.74.895-2.973s-.312-2.272-.895-2.973C14.769 8.385 13.817 7.8 12 7.8"
                    fill="currentColor"
                />
                <path d="M4.24 11.1a10.4 10.4 0 0 0 0 1.8H0v-1.8z" fill="currentColor" />
                <path d="M24 12.9h-4.24a10.4 10.4 0 0 0 0-1.8H24z" fill="currentColor" />
                <path d="M6.986 5.713A6.5 6.5 0 0 0 5.718 6.99l-2.84-2.84L4.15 2.878z" fill="currentColor" />
                <path d="m21.122 4.151-2.84 2.84a6.506 6.506 0 0 0-1.268-1.278l2.835-2.835z" fill="currentColor" />
                <path d="M12.9 4.236a11 11 0 0 0-1.8 0V0h1.8z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
SunOutlinedSize24Glyph.displayName = 'SunOutlinedSize24Glyph';
